import { useMutation, useQuery } from "@tanstack/react-query";
import { Form, Spin, message } from "antd";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { getAuthUserDetails } from "../../../network/auth";
import {
  addSalonProfile,
  getSubscriptionPlans,
} from "../../../network/onboarding";
import { updateStep5 } from "../../../services/store/slices/onboarding";
import { setUserData } from "../../../services/store/slices/user";
import PriceCard from "../PriceCard";

const Step5 = ({ nextStep, data, updateData }: any) => {
  const [fileData, setFileData] = useState<any>({});
  const [planId, setPlanId] = useState<any>(0);

  const { step1, step2, step3, step25, step5 } = useSelector(
    (state: any) => state?.SalonProfile,
  );
  const {
    data: planss,
    isLoading,
    isError,
  } = useQuery(["SubscriptionPlans"], () => getSubscriptionPlans());
  const FlowType = step25?.type === undefined ? "onsite" : step25?.type;
  const user = useSelector((state: any) => state?.user);

  const dispatch = useDispatch();
  const {
    mutate: onAddSalon,
    isLoading: isAddingSalon,
    error: addSalonError,
  } = useMutation(addSalonProfile, {
    onSuccess: (res: any) => {
      if (res?.status === 200) {
        getAuthUserDetails()
          .then((res) => {
            console.log(res);
            dispatch(
              setUserData({
                ...user?.data,
                user: { ...res?.data?.data },
              }),
            );
          })
          .catch((error) => console.log(error));

        message.success("Salon added successfully!");
        nextStep();
        // dispatch(emptyStep([]));
      } else {
        console.log(res?.response?.data?.message);
        message.error(res?.response?.data?.message);
        getAuthUserDetails()
          .then((res) => {
            console.log(user?.data, "res?.data?.data ");
            console.log(res?.data?.data, "res?.data?.data ");
            dispatch(
              setUserData({
                ...user?.data,
                user: { ...res?.data?.data },
              }),
            );
          })
          .catch((error) => console.log(error));
      }
    },
    onError: (error) => {
      console.log(error, "sasa");
      message.error("Failed to add salon. Please try again.");
    },
  });

  const AddSalon = (file?: any, skip = false, plan = 0) => {
    const formData = new FormData();
    if (!skip) {
      if (file) {
        // Ensure file is not undefined and check for originFileObj
        const actualFile = file.originFileObj ? file.originFileObj : file;
        formData.append("work_permit", actualFile);
      } else if (fileData) {
        // Fallback to use fileData from state if file parameter is not provided
        // Also check for originFileObj
        const actualFile = fileData.originFileObj
          ? fileData.originFileObj
          : fileData;
        formData.append("work_permit", actualFile);
      }
    }
    formData.append("name[ar]", step1?.name.ar);
    formData.append("website_url", step1?.website_url);
    formData.append("team_size_id", step1?.team_size_id);
    // formData.append("service_id", step2?.service_id);
    formData.append(
      "location[primary_service_categories][1]",
      step2?.service_id[0],
    );
    step2?.service_id
      .slice(1) // Skip the first element
      .forEach((id: string, index: number) => {
        formData.append(
          `location[secondary_service_categories][${index + 1}]`, // Start indexing from 1
          id,
        );
      });

    formData.append("type", FlowType);
    console.log(step3, "step3step3step3step3step3step3step3step3step3step3");
    if (step25.type === "freelancer") {
      formData.append("location[contact_number]", user?.data?.user?.phone);
      formData.append(
        "location[contact_country_code]",
        user?.data?.user?.phone_country_code,
      );
    } else {
      formData.append("location[name][ar]", step3?.name?.ar);
      formData.append("location[lat]", step3?.lat);
      formData.append("location[lng]", step3?.lng);

      formData.append("location[contact_number]", step3?.contact_number);
      formData.append(
        "location[contact_country_code]",
        step3?.contact_country_code,
      );
      formData.append("location[email]", step3?.email);
      formData.append(
        "location[business_location][Building]",
        step3?.business_location.Building,
      );
      formData.append(
        "location[business_location][Address]",
        step3?.business_location.Address,
      );
      // formData.append(
      //   "location[business_location][City]",
      //   step3?.business_location.City
      // );
      // formData.append(
      //   "location[business_location][Country]",
      //   step3?.business_location.Country
      // );
      formData.append(
        "location[business_location][District]",
        step3?.business_location.District,
      );
      formData.append(
        "location[business_location][streetName]",
        step3?.business_location.streetName,
      );
    }
    formData.append("plan_id", plan || step5?.plan);
    console.log(formData, "formDataformDataformDataformData");
    onAddSalon(formData);
  };

  const onFinish = (values: any) => {
    dispatch(updateStep5({ plan_id: planId }));

    nextStep();
    AddSalon({}, true, planId);
  };

  const [form] = Form.useForm();

  return (
    <Form
      className="w-full"
      name="step5"
      onFinish={onFinish}
      layout={"vertical"}
      form={form}
      dir="rtl"
    >
      <div className="p-2 text-center dir ">
        <h5 className="text-lg text-color-primary !font-medium mb-4">
          <FormattedMessage
            id="pricing.choose_appropriate_plan"
            defaultMessage="Choose the appropriate pricing plan for you!"
          />
        </h5>
        <p className="text-sm text-[#75757E]">
          <FormattedMessage
            id="pricing.plan_based_on_requirements"
            defaultMessage="Based on your requirements, the best plan for you has been suggested from the following..."
          />
        </p>
        <div className="flex justify-center w-full gap-12 lg:my-24 max-lg:my-4 max-lg:flex-col">
          {isLoading ? (
            <Spin className="flex justify-center" size="large" />
          ) : (
            planss?.data?.map((e: any) => {
              const feats = e?.features?.filter(
                (feature: any) =>
                  feature?.key !== "commission_new_online_bookings" &&
                  feature?.key !== "commission_recurring_online_bookings",
              );
              const commissions = e?.features?.filter(
                (feature: any) =>
                  feature?.key === "commission_new_online_bookings" ||
                  feature?.key === "commission_recurring_online_bookings",
              );
              return (
                <PriceCard
                  title={e.title}
                  name={e.name}
                  feats={feats}
                  id={e.id}
                  setPlanId={setPlanId}
                  commissions={commissions}
                  price={e.price}
                  recommended={e.id === 2}
                />
              );
            })
          )}
        </div>
      </div>
    </Form>
  );
};

export default Step5;
